import React, { useEffect, useState } from 'react';
import { db,collection,onSnapshot } from '../../config/firebase';
import * as XLSX from 'xlsx';
import { Button } from 'antd';

const FirestoreToExcel = () => {
    const [data, setData] = useState([]);
  
    useEffect(() => {
      // Initialize Firebase
  
  

      const q = collection(db, "Students");
   onSnapshot(q, (snapshot) => {
      const newData = [];
      snapshot.forEach((doc) => {
        newData.push(doc.data());
      });
      setData(newData);
    });
  }, []);
      // Replace 'collectionName' with the name of your Firestore collection
 
  
      // Fetch data from Firestore
    const exportToExcel = () => {
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(data);
      XLSX.utils.book_append_sheet(workbook, worksheet, 'All Users Status');

      XLSX.writeFile(workbook, 'All Users Status.xlsx');
    };
  
    return (
      <div>
        <Button onClick={exportToExcel}>Export to Excel</Button>
      </div>
    );
  };
  
  export default FirestoreToExcel;
  